import React from "react";
import Slider from "react-slick";
import {carouselSettings} from "../../common/utils";

const RebagCertifiedCarousel = () => {
    const slider_settings = {
        className: "rebag-certified__carousel",
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [],
        dotsClass: "slick-dots--custom",
    }
    const sliderSettings = carouselSettings(slider_settings);
    return (
        <div className="rebag-certified__carousel--container">
            <div className="rebag-certified__carousel--title">From Our Customers</div>
            <Slider {...sliderSettings}>
                <div className="rebag-certified__carousel--text">I got the best customer service- they went out of their way to send me extra photos of the bag I ended up purchasing. This was my first experience with them but I'll definitely be back!! 😍</div>
                <div className="rebag-certified__carousel--text">I received my order pretty fast and it was absolutely STUNNING!! It was packaged beautifully and the product was received just as described. I would DEFINITELY recommend shopping here!</div>
                <div className="rebag-certified__carousel--text">Absolutely love rebag. They're shipping and packing love it. I'm almost scared to use mine now lol. Like new!! Love it!!!!</div>
                <div className="rebag-certified__carousel--text">My shopping experience was wonderful. The description was accurate, the customer service was extremely prompt and courteous & shipping was excellent.</div>
            </Slider>
            <a href="https://www.google.com/shopping/ratings/account/lookup?q=rebag.com" target="_blank" className="rebag-certified__carousel--see-all">See All Reviews</a>
        </div>
    )
};

export default RebagCertifiedCarousel;